import React from 'react';
import classNames from 'classnames';
import { ISeance } from 'src/types/seance';
import styles from '../assets/seance-actions.module.scss';
import DeleteSeanceAction from './DeleteSeanceAction';
import DeleteSubstitutionAction from './DeleteSubstitutionAction';
import user from '../../../../../../../services/user-auth';
import UserRole from '../../../../../../../enumerables/user-role';

const SeanceActionsColumn: React.FunctionComponent<any> = ({
    original,
}: {
    original: ISeance;
    column: boolean;
    setColumn: (data: boolean) => void;
}) => {
    return (
        <div className={classNames(styles.actions)}>
            {/*   <button
                className={'btn btn-info'}
                onClick={() => {
                    setColumn(!column);
                }}
            >
                {column ? 'Less' : 'More'}
            </button>*/}
            {user.getRoles().includes(UserRole.ROLE_ADMIN) ? (
                <div className={classNames(styles.actionsWrap)}>
                    <DeleteSeanceAction data={original} />

                    {original.substitutedProvider ? <DeleteSubstitutionAction data={original} /> : null}
                </div>
            ) : null}
        </div>
    );
};

export default SeanceActionsColumn;
